export const lime = {
  sources: [
    {
      id: 'ag-lime',
      label: 'Ag Lime',
    },
    {
      id: 'pelletized-lime',
      label: 'Pelletized Lime (98G)',
      qualityPassThrough: 100,
    },
    {
      id: 'water-treatment-lime',
      label: 'Water Treatment Lime',
      qualityPassThrough: 100,
    },
  ],
  states: {
    AR: {
      label: 'Arkansas',
      referenceQuality: 100,
    },
    IA: {
      label: 'Iowa',
      referenceQuality: 1340,
      sieves: [4, 8, 60],
      calculateQuality: ({ ms4, ms8, ms60, cce }) =>
        (((ms4 * 0.1 + ms8 * 0.3 + ms60 * 0.6) * (cce / 100)) / 100) * 2000,
    },
    IL: {
      label: 'Illinois',
      referenceQuality: 67.5,
      sieves: [8, 30, 60],
      calculateQuality: ({ ms8, ms30, ms60, cce }) =>
        ((100 - ms8) * 0.15 + (ms8 - ms30) * 0.45 + (ms30 - ms60) + ms60) * (cce / 100),
    },
    IN: {
      label: 'Indiana',
      referenceQuality: 65,
      sieves: [8, 60],
      calculateQuality: ({ ms8, ms60, cce }) => ((ms8 + ms60) / 2) * (cce / 100),
    },
    KS: {
      label: 'Kansas',
      referenceQuality: 100,
    },
    KY: {
      label: 'Kentucky',
      referenceQuality: 67,
      sieves: [10, 50],
      calculateQuality: ({ ms10, ms50, cce }) => ((ms10 + ms50) / 2) * (cce / 100),
    },
    MI: {
      label: 'Michigan',
      referenceQuality: 90,
      sieves: [8, 60],
      calculateQuality: ({ ms8, ms60, cce }) => ((ms8 - ms60) * 0.5 + ms60) * (cce / 100),
    },
    MN: {
      label: 'Minnesota',
      referenceQuality: 100,
      sieves: [8, 20, 60],
      calculateQuality: ({ ms8, ms20, ms60, cce }) => ((ms8 - ms20) * 0.2 + (ms20 - ms60) * 0.6 + ms60) * (cce / 100),
    },
    MO: {
      label: 'Missouri',
      referenceQuality: 800,
      sieves: [8, 40, 60],
      calculateQuality: ({ ms8, ms40, ms60, cce }) =>
        (((ms8 - ms40) * 0.25 + (ms40 - ms60) * 0.6 + ms60) * (cce / 100) * 800) / 100,
    },
    NE: {
      label: 'Nebraska',
      referenceQuality: 60,
    },
    OH: {
      label: 'Ohio',
      referenceQuality: 1340,
      sieves: [8, 20, 60, 100],
      calculateQuality: ({ ms8, ms20, ms60, cce }) =>
        ((((ms8 - ms20) * 0.2 + (ms20 - ms60) * 0.6 + ms60) * (cce / 100)) / 100) * 2000,
    },
    OK: {
      label: 'Oklahoma',
      referenceQuality: 67,
      sieves: [8, 60],
      calculateQuality: ({ ms8, ms60, cce }) => (ms8 / 2 + ms60 / 2) * (cce / 100),
    },
    PA: {
      label: 'Pennsylvania',
      referenceQuality: 80,
      sieves: [20, 60, 100],
      calculateQuality: ({ ms20, ms60, ms100, cce }) =>
        ((ms20 - ms60) * 0.4 + (ms60 - ms100) * 0.8 + ms100) * (cce / 100),
    },
    TN: {
      label: 'Tennessee',
      referenceQuality: 65,
    },
    WI: {
      label: 'Wisconsin',
      referenceQuality: 65,
      sieves: [8, 20, 60],
      calculateQuality: ({ ms8, ms20, ms60, cce }) => ((ms8 - ms20) * 0.2 + (ms20 - ms60) * 0.6 + ms60) * (cce / 100),
    },
  },
};
